import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import React from "react";
import { handleChangeHeader } from "../../../../../utils/commonFunctions/fieldCapitalize";
import { pink } from "@mui/material/colors";
import {
	firstFieldAppealsList_v2,
	firstFieldFilterAppealsList_v2,
	firstFieldFilterPaidClaimsList_v2,
	secondFieldAppealsList_v2,
	secondFieldFilterAppealsList_v2,
	secondFieldFilterPaidClaimsList_v2
} from "../../../../../constants/fieldsList/FieldsList";
import { PaidClaimsCustomFilterProps } from "../../../../../@types/appealReportAllprops.types";

const PaidClaimsCustomFilter: React.FC<PaidClaimsCustomFilterProps> = ({
	filteredColumns,
	handleUpdateFiltersSelection,
	handleFilterChange,
	ensureDateFilter,
	getInputType,
	filters
}) => {
	return (
		<div>
			<div
				style={{
					width: "100%",
					margin: "auto",
					textAlign: "center",
					fontWeight: "bolder",
					color: "#ab455c",
					fontSize: "20px",
					marginBottom: "20px"
				}}
			>
				Paid Claims
			</div>
			<div className="fieldContainer">
				<Grid container spacing={4}>
					{[firstFieldFilterPaidClaimsList_v2, secondFieldFilterPaidClaimsList_v2].map(
						(fieldList, columnIndex) => (
							<Grid item xs={12} sm={12} md={6} key={columnIndex}>
								<Grid container style={{ marginBottom: "1rem", color: "#ab455c", fontWeight: "bold" }}>
									<Grid item xs={6}>
										FIELD NAME
									</Grid>
									<Grid item xs={6} style={{ textAlign: "center" }}>
										VIEW
									</Grid>
								</Grid>
								{fieldList.map((field, index) => (
									<Grid container key={index} style={{ marginBottom: "1rem" }} alignItems="center">
										<Grid item xs={6}>
											{handleChangeHeader(field).replace("CHEQUE", "CHECK")}
										</Grid>
										<Grid item xs={6} style={{ textAlign: "center" }}>
											<Checkbox
												checked={filteredColumns.paidclaims[field]}
												sx={{
													color: pink[800],
													"&.Mui-checked": { color: pink[600] }
												}}
												onChange={(event: any) =>
													handleUpdateFiltersSelection(
														field,
														event.target.checked,
														"paidclaims"
													)
												}
											/>
										</Grid>
										{filteredColumns.paidclaims[field] && (
											<Grid container spacing={2}>
												{getInputType(field) === "date" && (
													<>
														<Grid item xs={6}>
															<TextField
																fullWidth
																label="Start Date"
																type="date"
																value={ensureDateFilter("paidclaims", field).startDate}
																onChange={(e: any) =>
																	handleFilterChange("paidclaims", field, {
																		...ensureDateFilter("paidclaims", field),
																		startDate: e.target.value
																	})
																}
																InputLabelProps={{
																	shrink: true // Keep label visible
																}}
															/>
														</Grid>
														<Grid item xs={6}>
															<TextField
																fullWidth
																label="End Date"
																type="date"
																value={ensureDateFilter("paidclaims", field).endDate}
																onChange={(e: any) =>
																	handleFilterChange("paidclaims", field, {
																		...ensureDateFilter("paidclaims", field),
																		endDate: e.target.value
																	})
																}
																InputLabelProps={{
																	shrink: true // Keep label visible
																}}
															/>
														</Grid>
													</>
												)}
												{getInputType(field) === "number" && (
													<Grid item xs={12}>
														<TextField
															fullWidth
															label="Enter Value"
															type="number"
															value={filters.paidclaims[field] || ""}
															onChange={(e: any) =>
																handleFilterChange("paidclaims", field, e.target.value)
															}
															InputLabelProps={{
																shrink: true
															}}
														/>
													</Grid>
												)}
												{getInputType(field) === "text" && (
													<Grid item xs={12}>
														<TextField
															fullWidth
															label="Enter Value"
															type="text"
															value={filters.paidclaims[field] || ""}
															onChange={(e: any) =>
																handleFilterChange("paidclaims", field, e.target.value)
															}
															InputLabelProps={{
																shrink: true
															}}
														/>
													</Grid>
												)}
												{getInputType(field) === "boolean" && (
													<Grid item xs={12}>
														<FormControlLabel
															control={
																<Checkbox
																	checked={filters.paidclaims[field] === true}
																	onChange={(e: any) =>
																		handleFilterChange(
																			"paidclaims",
																			field,
																			e.target.checked
																		)
																	}
																	color="primary"
																/>
															}
															label="True"
														/>
														<FormControlLabel
															control={
																<Checkbox
																	checked={filters.paidclaims[field] === false}
																	onChange={(e: any) =>
																		handleFilterChange(
																			"paidclaims",
																			field,
																			!e.target.checked
																		)
																	}
																	color="secondary"
																/>
															}
															label="False"
														/>
													</Grid>
												)}
											</Grid>
										)}
									</Grid>
								))}
							</Grid>
						)
					)}
				</Grid>
			</div>
		</div>
	);
};

export default PaidClaimsCustomFilter;
